import React from 'react';
import {DropdownMenu, ButtonDropdown} from "reactstrap";

/**
 * Obalovací třída pro kontextové menu.
 * Použití:
 * <ContextMenu>
 *   <DropdownItem></DropdownItem>
 * </ContextMenu>
 */
export default class ContextMenu extends React.Component {
    render() {
        return (
            <ButtonDropdown isOpen toggle={()=>{}} className="context-menu-container">
                <DropdownMenu>
                    {this.props.children}
                </DropdownMenu>
            </ButtonDropdown>
        );
    }
};
